import * as React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Container'
import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

const WhiteBox = styled(Box)`
  width: 50vw;
  /* max-width: 400px; */
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border-radius: 0.5rem;
  color: black;
  overflow: hidden;
  font-size: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.89);
  padding: 20px;
`

const ColorButton = styled(Link)(({ theme }) => ({
  color: '#000',
  height: 'auto',
  backgroundColor: '#ffff',
  padding: '10px 20px',
  textDecoration: 'none',
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: 'rgba(116, 31, 138, 0.4)',
    color: 'white'
  }
}))

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden',
    background: 'linear-gradient(-90deg, rgba(246,147,28,1) 0%, rgba(240,94,35,1) 50%)',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paperContainer: {
    backgroundImage: `url(/assets/backgroundSelect.png)`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1
  }
}))

export default function ForgotPassword() {
  const classes = useStyles()
  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.root}>
        <div className={classes.paperContainer} />
        {/* <WhiteBox> */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <ErrorOutlineIcon sx={{ fontSize: 80, color: 'white' }} />
            <Typography variant="h1" sx={{ color: 'white', fontWeight: 'bold', fontSize: '4rem' }}>
              404
            </Typography>
            <Typography variant="h6" sx={{ color: 'white' }}>
              Ops! Página não encontrada.
            </Typography>
            <ColorButton to="/" key="home">
              Início
            </ColorButton>
          </Box>
        {/* </WhiteBox> */}
      </div>
    </React.Fragment>
  )
}
